<template>
    <div class="inputGroup"
         :class="{'hasValidation': required}"
         :id="leadKey">
        <input v-if="mask"
               ref="input"
               type="text"
               :placeholder="placeholder"
               :value="value"
               v-mask="mask"
               @focus="handleFocus"
               @blur="handleBlur"
               @input="updateInput($event, leadKey)" />
        <input v-if="!mask"
               ref="input"
               type="text"
               :placeholder="placeholder"
               :value="value"
               @focus="handleFocus"
               @blur="handleBlur"
               @input="updateInput($event, leadKey)" />
               <slot />
        <div class="errorMessages"
             v-show="errors[leadKey]">
            <div v-for="message in errors[leadKey]"> {{ message }} </div>
        </div>
    </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["placeholder", "value", "leadKey", "mask"],
  props: {
    placeholder: {},
    value: {},
    leadKey: {},
    mask: {
      default: false
    },
    required: {
      default: true
    }
  },
  computed: {
    ...mapState(["lead", "errors"])
  },
  methods: {
    ...mapActions([]),

    updateInput(e, key) {
      let data = {
        key,
        value: e.target.value
      };
      this.$store.commit("SET_LEAD_VALUE", data);
    },

    validate(val) {
      let errors = {};
      let valid = false;
      let isEmail = this.leadKey === "email";

      if (!val) {
        errors[this.leadKey] = ["This field is required"];
      }

      if (isEmail) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        valid = re.test(val);

        if (valid === false) {
          errors[this.leadKey] = ["A valid email address is required"];
        }
      }

      if (Object.keys(errors).length) {
        this.$store.commit("ADD_ERRORS", errors);
      }

      if (val && !isEmail) {
        this.$store.commit("REMOVE_ERRORS", this.leadKey);
      }

      if (isEmail) {
        if (val && valid) {
          this.$store.commit("REMOVE_ERRORS", this.leadKey);
        }
      }
    },

    handleBlur(e) {
      let value = this.value;
      if (this.required) {
        this.validate(value);
      }
    },

    handleFocus(e) {
      delete this.$store.state.errors[this.leadKey];
    }
  }
};
</script>

<style lang="css"></style>
